import { render } from "./EnrolmentReview.vue?vue&type=template&id=40eb7fd9"
import script from "./EnrolmentReview.vue?vue&type=script&lang=ts"
export * from "./EnrolmentReview.vue?vue&type=script&lang=ts"
script.render = render

export default script